<template>
    <ae-container>
        <template slot="top-left">
            <home-top-coach
                    :indicators="home.top"
                    mode="light"
            />
        </template>
        <template slot="middle-left">
            <home-middle-meeting
                    v-if="home.meetings.length > 0"
                    :meeting="home.meetings[0]"
                    class="p-1 px-2"
                    mode="light"
            />
            <home-placeholder
                    v-else
                    target="meetings"
            />
        </template>
        <template
                v-if="hasRoleReferent"
                slot="bottom-left"
        >
            <h5 class="font-weight-bold text-primary text-center my-1">
                <i class="fas fa-bullhorn"/>
                Rappels
            </h5>
            <home-bottom-reminder
                    v-for="(todo, i) of reminders(4)"
                    :key="`home-coach-todo-list-${i}`"
                    :reminder="todo"
                    class="p-1 mb-0 mt-1 br-3"
            />
            <div v-if="reminders(4).length === 0">
                <p class="text-center my-0 text-muted">Vous n'avez aucune tâche à effectuer</p>
            </div>
        </template>
        <template slot="center">
            <referent-roadlog
                    v-if="hasRoleReferent"
                    style="margin-top: 3px"
            />
            <template v-else>
                <coach-roadlog
                        class="mt-1 mb-2"
                />
                <div class="bg-whitesmoke h-100 p-1">
                    <ae-block class="py-1">
                        <h5 class="font-weight-bold text-primary text-center m-0">
                            <i class="fas fa-bullhorn"/>
                            Rappels
                        </h5>
                    </ae-block>
                    <home-bottom-reminder
                            v-for="(todo, i) of reminders(4)"
                            :key="`home-coach-todo-list-${i}`"
                            :reminder="todo"
                            class="p-1 pr-4 mb-0 mt-1 br-3"
                    />
                    <ae-block
                            v-if="reminders(4).length === 0"
                            class="py-4"
                    >
                        <p class="text-center my-0 text-muted">Vous n'avez aucune tâche à effectuer</p>
                    </ae-block>
                </div>
            </template>
        </template>
        <template slot="top-right">
            <h2 class="bg-whitesmoke my-0 br-3 p-1 mb-2"><b><i class="fas fa-child"/> Mes prochaines séances</b></h2>
            <meeting-by-day-list
                    :meetings="home.meetings"
            />
            <p
                    v-if="home.meetings.length === 0"
                    class="text-center mt-2"
            >
                Vous n'avez aucune séance à venir
            </p>
        </template>
    </ae-container>
</template>
<script>
    import AeContainer from "../../Container";
    import HomeTopCoach from "../top/Coach";
    import HomeMiddleMeeting from "../middle/Meeting";
    import HomePlaceholder from "../Placeholder";
    import HomeBottomReminder from "../bottom/Reminder";
    import ReferentRoadlog from "../../../views/referent/Roadlog";
    import CoachRoadlog from "../../../views/coach/RoadlogInfo";
    import MeetingByDayList from "../../meeting/ByDay/List";
    import Roadlog from "../../../views/Roadlog";
    import AeBlock from "../../Block";

    export default {
        name: 'home-desktop-coach',
        components: {
            AeBlock,
            Roadlog,
            MeetingByDayList,
            ReferentRoadlog,
            HomeBottomReminder,
            HomePlaceholder,
            HomeMiddleMeeting,
            HomeTopCoach,
            AeContainer,
            CoachRoadlog
        },
        computed: {
            hasRoleReferent() {
                return this.$store.getters['base/account/getIsCoachReferent'](this.user)
            },
            user() {
                return this.$store.state.base.account.information
            },
            home() {
                return this.$store.state.base.appInterface.home
            },
            profileLink() {
                return {
                    name: 'account-settings'
                }
            },
            folder() {
                return `/static/img/icons/navbar/${this.iconsColor}/`
            },
            color() {
                let color = 'bleu'
                if (
                    this.interface &&
                    this.interface.colors &&
                    this.interface.colors.navbar &&
                    this.interface.colors.navbar['icon-color']
                ) color = this.interface.colors.navbar['icon-color']
                return color
            },
            iconsColor() {
                const color = this.color
                switch (color) {
                    case 'bleu':
                        return 'blue'
                    case 'noir':
                        return 'black'
                    case 'blanc':
                    default:
                        return 'white'
                }
            },
            fullName() {
                return this.$store.getters['base/account/getFullName'](this.user)
            },
            profilePicture() {
                return this.$store.getters['base/account/getAvatar'](this.user) !== '/static/img/icons/user.png' ?
                    this.$store.getters['base/account/getAvatar'](this.user) : `${this.folder}profile.png`
            },
        },
        methods: {
            reminders(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'coach_todo'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            }
        }
    }
</script>
